import { render, staticRenderFns } from "./ModalWizard.vue?vue&type=template&id=55bae1fe&"
import script from "./ModalWizard.vue?vue&type=script&lang=js&"
export * from "./ModalWizard.vue?vue&type=script&lang=js&"
import style0 from "./ModalWizard.vue?vue&type=style&index=0&id=55bae1fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports